// Template259: Bélgica - Transporte (Subway.jsx)
// Cabecera Transporte en Bélgica, intro (2 párrafos), caja Tren SNCB (lista + sticker + tip), sección Billetes y abonos.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template259 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro1 = page?.texts?.[1]?.content;
	const intro2 = page?.texts?.[2]?.content;
	const trenTitle = page?.texts?.[3]?.content;
	const trenListHtml = page?.texts?.[4]?.content;
	const tipTren = page?.texts?.[5]?.content;
	const billetesTitle = page?.texts?.[6]?.content;
	const billetesListHtml = page?.texts?.[7]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
		color: "#8b6914",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro1 && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={estiloP}>
						{intro1}
					</Box>
				</Box>
			)}
			{intro2 && (
				<Box data-block-id="text-2" sx={{ padding: "0px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={estiloP}>
						{intro2}
					</Box>
				</Box>
			)}

			{/* Caja Tren SNCB */}
			<Box
				data-block-id="text-3"
				sx={{
					backgroundColor: "#fff8db",
					border: "2px solid #D4A017",
					borderRadius: "16px",
					padding: "16px",
					margin: "0 16px 16px 16px",
					position: "relative",
					marginTop: "12px",
				}}
			>
				{trenTitle && (
					<Box component="h3" sx={estiloH3}>
						{trenTitle}
					</Box>
				)}
				{trenListHtml && (
					<Box
						component="ul"
						sx={{
							paddingLeft: 2,
							margin: 0,
							fontSize: 13,
							"& a": { color: "#8b6914" },
						}}
						dangerouslySetInnerHTML={{ __html: trenListHtml }}
					/>
				)}
				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -110 : -90,
							right: 12,
						}}
					/>
				)}
				{tipTren && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? -60 : -40,
							right: 100,
							backgroundColor: "#fff8db",
							border: "2px solid #D4A017",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: "11px",
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 300,
						}}
					>
						{tipTren}
					</Box>
				)}
			</Box>

			{/* Billetes y abonos */}
			{(billetesTitle || billetesListHtml) && (
				<Box
					data-block-id="text-4"
					sx={{
						padding: "0 16px",
						fontSize: 13,
						color: "#444",
						marginTop: isSmallScreen ? "80px" : "40px",
					}}
				>
					{billetesTitle && (
						<Box component="h3" sx={estiloH3}>
							{billetesTitle}
						</Box>
					)}
					{billetesListHtml && (
						<Box
							component="ul"
							sx={{ paddingLeft: 2 }}
							dangerouslySetInnerHTML={{ __html: billetesListHtml }}
						/>
					)}
				</Box>
			)}
		</Box>
	);
};

Template259.thumbnail = "/images/template-1.png";
export default Template259;
